import React, { useEffect, useState } from "react";
import { FlaskConical, MessageSquareText } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../../lib/api";
import { D, Btn, inputStyle } from "../../ui";

// Aksi bandara: ubah kata pemicu komentar + simulasi lonjakan FYP (N komentar palsu, tanpa akun Meta)
export function BandaraAksi({ token, d, onChanged }) {
  const [kata, setKata] = useState(d.kata_pemicu);
  const [jumlah, setJumlah] = useState(30);
  const [busy, setBusy] = useState(false);
  useEffect(() => setKata(d.kata_pemicu), [d.kata_pemicu]);

  async function simpanKata(e) {
    e.preventDefault();
    try { const r = await api.adminKataPemicu(token, kata); toast.success(`Kata pemicu: “${r.kata}”`); onChanged(); } catch (err) { toast.error(err.message); }
  }
  async function simulasi() {
    if (!window.confirm(`Buat ${jumlah} komentar palsu “${d.kata_pemicu} <warna>”? Mereka akan benar-benar dijadwalkan terbang di beranda.`)) return;
    setBusy(true);
    try { const r = await api.adminSimulasiKomentar(token, jumlah); toast.success(`${r.baru} pendatang baru · ${r.antre} kursi antre`); onChanged(); } catch (err) { toast.error(err.message); }
    setBusy(false);
  }

  const blok = { padding: "12px 14px", borderRadius: 16, background: D.cream, display: "flex", flexDirection: "column", gap: 8 };
  const label = { fontSize: 10.5, fontWeight: 800, letterSpacing: 1.2, textTransform: "uppercase", color: D.sub };
  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
      <form onSubmit={simpanKata} data-testid="bandara-kata-form" style={{ ...blok, flex: 1, minWidth: 220 }}>
        <span style={label}><MessageSquareText size={11} style={{ verticalAlign: -1 }} /> Kata pemicu komentar</span>
        <div style={{ display: "flex", gap: 8 }}>
          <input data-testid="bandara-kata-input" value={kata} onChange={e => setKata(e.target.value)} style={{ ...inputStyle, background: "#fff", padding: "9px 12px" }} required />
          <Btn type="submit" small testid="bandara-kata-simpan" disabled={!kata.trim() || kata.trim().toLowerCase() === d.kata_pemicu}>Simpan</Btn>
        </div>
        <span style={{ fontSize: 11.5, color: D.sub }}>Komentar yang memuat kata ini masuk antrean terjun; warna pertama yang disebut jadi warna payung.</span>
      </form>
      <div data-testid="bandara-simulasi" style={{ ...blok, flex: 1, minWidth: 220 }}>
        <span style={label}><FlaskConical size={11} style={{ verticalAlign: -1 }} /> Simulasi lonjakan FYP</span>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <input data-testid="bandara-simulasi-jumlah" type="number" min={1} max={300} value={jumlah} onChange={e => setJumlah(Math.max(1, Math.min(300, Number(e.target.value) || 1)))} style={{ ...inputStyle, background: "#fff", width: 90, padding: "9px 12px" }} />
          <span style={{ fontSize: 12.5, color: D.ink }}>komentar palsu</span>
          <span style={{ flex: 1 }} />
          <Btn small variant="dark" testid="bandara-simulasi-jalankan" disabled={busy} onClick={simulasi}>Jalankan</Btn>
        </div>
        <span style={{ fontSize: 11.5, color: D.sub }}>Menguji tempo slot (1 menit saat ramai), kapasitas adaptif 6/10/15/30, dan variasi balasan. Hapus hasilnya lewat tab Pendatang.</span>
      </div>
    </div>
  );
}
